import { render } from "./ProjectUpdate.vue?vue&type=template&id=64410958"
import script from "./ProjectUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__